import React from 'react';
import styled from 'styled-components';
import { DefaultPalette, Slider, Stack, IStackStyles, IStackTokens } from '@fluentui/react';
import { ResponsivePie } from '@nivo/pie'

const itemStyles = {
    alignItems: 'center',
    background: '#f2f2f2',
    height: '300px',
    width: '400px',
    justifyContent: 'center',
};

const stackStyles = {
    root: {
        width: `100%`
    },
};

const stackWrapperStyles = {
    backgroundColor: `#000000`,
    height: `100vh`
};

const Title = styled.div`
    width: 100%;
    text-align: center;
    margin-top: 20px;
    font-weight: bold;
`;

const TotalCount = styled.div`
    margin-top: -110px;
    margin-left: 15px;
`;

const data = [
    {
        "id": "Gen Y (อายุ 26-43 ปี) : 254 คน ",
        "label": "Gen Y (อายุ 26-43 ปี)",
        "value": 55.58,
        "color": "hsl(298, 70%, 50%)",
    },
    {
        "id": "Gen X (อายุ 44-58 ปี) : 137 คน ",
        "label": "Gen X (อายุ 44-58 ปี)",
        "value": 29.98,
        "color": "hsl(225, 70%, 50%)",
    },
    {
        "id": "Gen Z (อายุต่ำกว่าหรือเท่ากับ 25 ปี): 36 คน ",
        "label": "Gen Z (อายุต่ำกว่าหรือเท่ากับ 25 ปี)",
        "value": 7.88,
        "color": "hsl(24, 70%, 50%)",
    },
    {
        "id": "Baby Boomer (อายุ 59-77 ปี) : 29 คน ",
        "label": "Baby Boomer (อายุ 59-77 ปี)",
        "value": 6.35,
        "color": "hsl(213, 70%, 50%)",
    },
    {
        "id": "Silent Generation (อายุ 78-101 ปี) : 1 คน ",
        "label": "Silent Generation (อายุ 78-101 ปี)",
        "value": 0.21,
        "color": "hsl(138, 70%, 50%)",
        "count": "1"
    }
    
];

const colors = {
    'มีอาหารที่อร่อยและมีความเฉพาะถิ่นคุ้มค่าต่อการมาท่องเที่ยว': '#ffc8b0',
    'ความสวยงามและความน่าสนใจของแหล่งท่องเที่ยว': '#ffc8b0',
    'การเดินทางมาท่องเที่ยวที่สะดวกรวดเร็ว': '#ffc8b0'
}
const getColor = bar => colors[bar.id]

// Tokens definition
const sectionStackTokens = { childrenGap: 10 };
const wrapStackTokens = { childrenGap: 10 };


class Age extends React.Component {

    render() {
        return (
            <span style={itemStyles}>
                <Title>กลุ่มอายุของผู้ตอบแบบสอบถาม</Title>
                <ResponsivePie
                    data={data}
                    sortByValue={true}
                    margin={{ top: 30, right: -190, bottom: 80, left: 0 }}
                    innerRadius={0.5}
                    padAngle={0.7}
                    cornerRadius={3}
                    activeOuterRadiusOffset={8}
                    borderWidth={1}
                    borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                    enableArcLinkLabels={false}
                    arcLabel={function(e){return e.value+"%"}}
                    arcLabelsSkipAngle={10}
                    arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
                    defs={[
                        {
                            id: 'dots',
                            type: 'patternDots',
                            background: 'inherit',
                            color: 'rgba(255, 255, 255, 0.3)',
                            size: 4,
                            padding: 1,
                            stagger: true
                        },
                        {
                            id: 'lines',
                            type: 'patternLines',
                            background: 'inherit',
                            color: 'rgba(255, 255, 255, 0.3)',
                            rotation: -45,
                            lineWidth: 6,
                            spacing: 10
                        }
                    ]}
                    fill={[
                        {
                            match: {
                                id: 'ruby'
                            },
                            id: 'dots'
                        },
                        {
                            match: {
                                id: 'c'
                            },
                            id: 'dots'
                        },
                        {
                            match: {
                                id: 'go'
                            },
                            id: 'dots'
                        },
                        {
                            match: {
                                id: 'python'
                            },
                            id: 'dots'
                        },
                        {
                            match: {
                                id: 'scala'
                            },
                            id: 'lines'
                        },
                        {
                            match: {
                                id: 'lisp'
                            },
                            id: 'lines'
                        },
                        {
                            match: {
                                id: 'elixir'
                            },
                            id: 'lines'
                        },
                        {
                            match: {
                                id: 'javascript'
                            },
                            id: 'lines'
                        }
                    ]} legends={[
                        {
                            anchor: 'top-left',
                            direction: 'column',
                            justify: false,
                            translateX: 10,
                            translateY: 10,
                            itemsSpacing: 6,
                            itemWidth: 81,
                            itemHeight: 16,
                            itemTextColor: '#999',
                            itemDirection: 'left-to-right',
                            itemOpacity: 1,
                            symbolSize: 13,
                            symbolShape: 'circle',
                            effects: [
                                {
                                    on: 'hover',
                                    style: {
                                        itemTextColor: '#000'
                                    }
                                }
                            ]
                        }
                    ]}
                />
                <TotalCount><h3>457 คน</h3></TotalCount>
            </span>
        );
    }
}

export default Age;